import {useContext, useMemo} from "react";

import {QuickReplyService} from "../../../services/quickReply";
import HTTPContext from "../../contexts/HTTPContext";

export const useQuickReplyService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new QuickReplyService(http), [http]);
};
